<div [class.betslip-over-ask-pick--removed]="isRemoved()">
    @switch (props.overAskPick.pick.id.getPickType()) {
        @case (pickTypes.V2ParticipantPick) {
            <bs-betslip-over-aks-pick-participant [props]="props">
                <ng-container remove-button *ngTemplateOutlet="removeButtonTemplate" />
                <ng-container price-changes *ngTemplateOutlet="priceChangesTemplate" />
                <ng-container multi-single-possible-winnings *ngTemplateOutlet="multiSinglePossibleWinnings" />
            </bs-betslip-over-aks-pick-participant>
        }
        @case (pickTypes.BetBuilderPick) {
            <bs-betslip-over-aks-pick-bet-builder [props]="props">
                <ng-container remove-button *ngTemplateOutlet="removeButtonTemplate" />
                <ng-container price-changes *ngTemplateOutlet="priceChangesTemplate" />
                <ng-container multi-single-possible-winnings *ngTemplateOutlet="multiSinglePossibleWinnings" />
            </bs-betslip-over-aks-pick-bet-builder>
        }
        @case (pickTypes.GroupedPicks) {
            <bs-digital-over-ask-group-pick class="over-ask-sgp-pick-list" [props]="props" [oddsDisplayFormat]="oddsDisplayFormat" />
        }
        @default {
            <bs-betslip-over-aks-pick-option-market [props]="props">
                <ng-container remove-button *ngTemplateOutlet="removeButtonTemplate" />
                <ng-container price-changes *ngTemplateOutlet="priceChangesTemplate" />
                <ng-container multi-single-possible-winnings *ngTemplateOutlet="multiSinglePossibleWinnings" />
            </bs-betslip-over-aks-pick-option-market>
        }
    }
</div>

<ng-template #removeButtonTemplate>
    @if (canBetBeRemoved()) {
        <bs-digital-over-ask-bet-remove [pickId]="props.overAskPick.pick.id" [isRemoved]="isRemoved()" [class.removed]="isRemoved()" />
    }
</ng-template>

<ng-template #priceChangesTemplate>
    @if (isPendingState()) {
        <div class="betslip-over-ask-pick__odds">{{ getprice() }}</div>
    }
    @if (isReviewState()) {
        <bs-digital-over-ask-pick-changes [props]="getPriceChangesProps()" [oddsDisplayFormat]="oddsDisplayFormat" />
    }
</ng-template>

<ng-template #multiSinglePossibleWinnings>
    @if (isReviewState() && isMultiSingle && !isRemoved() && !isClosedOrLocked()) {
        <bs-betslip-over-ask-pick-possible-winnings [pickId]="props.overAskPick.pick.id" />
    }
</ng-template>
